/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_CredentialInputs */

const es_chat_tool_detail_credential = /** @type {(inputs: Chat_Tool_Detail_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const en_chat_tool_detail_credential = /** @type {(inputs: Chat_Tool_Detail_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Chat_Tool_Detail_CredentialInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_credential = /** @type {((inputs?: Chat_Tool_Detail_CredentialInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_CredentialInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_credential(inputs)
	return en_chat_tool_detail_credential(inputs)
});
export { chat_tool_detail_credential as "chat.tool_detail.credential" }